import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Armas tu clase con estructura clara',
  desc: 'Eliges progresiones y organizas la sesión con objetivos definidos.'
}, {
  num: '2',
  title: 'Entrenas por niveles y cuidas la seguridad',
  desc: 'Aplicas guías de orden técnico para cada etapa del gimnasta.'
}, {
  num: '3',
  title: 'Mides, ajustas y comunicas mejor',
  desc: 'Sigues avances, registras logros y explicas el proceso a las familias.'
}];
export function SimpleSteps() {
  return <section className="w-full bg-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-193">
      <div className="max-w-5xl mx-auto" data-id="element-194">
        <div className="text-center mb-16" data-id="element-195">
          <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-196">
            Simple
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy mb-4" data-id="element-197">
            Cómo te ayuda desde el primer día
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-198">En solo 3 pasos.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-199">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 relative pt-12" data-id="element-200">
              <div className="absolute -top-6 left-8 w-12 h-12 rounded-full bg-primary text-white font-heading font-black text-2xl flex items-center justify-center shadow-lg border-4 border-cream" data-id="element-201">
                {step.num}
              </div>
              <h3 className="font-bold text-navy text-xl mb-3 leading-tight" data-id="element-202">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-203">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}